import { getConfig } from '../config/configuration';
import type { HpDispatchFunction } from './actionTypes';
import { fetchResolver } from './fetchResolver';
import { ErrorMap } from 'interfaces/errorTypes';
import { FullPolicyData } from 'interfaces/customerDataTypes';

interface GetPaymentGuidActionProps {
  selectedPolicy: FullPolicyData;
  amount: number;
  source: string;
  username: string;
  paymentType?: 'monthly' | 'yearly' | 'unspecified';
  policyDetailsId: string;
  historyId: number;
  isAgent: boolean;
}

export function getPaymentGuidAction({
  selectedPolicy,
  amount,
  source,
  username,
  paymentType = 'unspecified',
  policyDetailsId,
  historyId,
  isAgent
}: GetPaymentGuidActionProps) {
  return (dispatch: HpDispatchFunction<ErrorMap | { [key: string]: string }>): Promise<void> | undefined => {
    dispatch({ type: 'PAYMENT_GUID_LOADING' });
    const {
      title,
      forename,
      surname,
      policyNumber,
      braintreeId,
      phoneNumber,
      correspondenceAddress,
      correspondencePostcode
    } = selectedPolicy;

    const data = {
      policyDetailsId,
      historyId,
      title,
      forename,
      surname,
      policyRef: policyNumber,
      insuredPartyCustomerId: braintreeId,
      amount,
      phoneNumber,
      correspondenceAddress,
      correspondencePostcode,
      source,
      username,
      paymentType,
      isAgent
    };

    const { websiteEndpoint } = getConfig();
    const url = `${websiteEndpoint}/api/payments/setup-payment`;

    return fetchResolver<any>({
      options: { url, data, method: 'POST', description: `Set up a new payment and return the payment guid` },
      dispatch,
      successAction: (response) => {
        dispatch({ type: 'PAYMENT_GUID_SUCCESS', payload: response });
      },
      failedAction: () => {
        dispatch({ type: 'PAYMENT_GUID_ERROR' });
      }
    });
  };
}
